import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Utils from 'libs/Utils';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import BackButton from 'components/BackButton';
import Modal from 'components/Modal';
import FormControl from 'components/FormControl';

import './styles.css';
import search from './img/search.svg';

class SelectCoin extends Component {
  static submit(e) {
    e.preventDefault();
  }

  constructor(props) {
    super(props);

    this.renderCoin = this.renderCoin.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.search = this.search.bind(this);
    this.onSearch = this.onSearch.bind(this);

    this.state = {
      search: '',
      coins: [],
    };
  }

  componentWillMount() {
    Utils.setBackgroundColor('#fff');

    this.setState({
      coins: this.props.coinStore.coins,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.coinStore.coins.length !== this.state.coins.length && !this.state.search) {
      this.setState({
        coins: nextProps.coinStore.coins,
      });
    }
  }

  componentWillUnmount() {
    Utils.setBackgroundColor('');
  }

  onSearch(e) {
    this.search(e.target.value);
  }

  search(value) {
    if (value === '') {
      return this.setState({
        search: '',
        coins: this.props.coinStore.coins,
      });
    }

    this.setState({
      search: value,
    });

    return this.props.coinStore.constructor.searchCoins(value, (error, coins) => {
      if (error) return console.log(error);
      return this.setState({
        coins,
      });
    });
  }

  loadMore() {
    this.props.coinStore.getCoins({ offset: this.props.coinStore.coins.length }, (error) => {
      if (error) return console.log(error);
      return false;
    });
  }

  renderCoin(coin, i) {
    let icon;
    switch (coin.iconType) {
      case 'vector':
        icon = (
          <img
            className="coin__icon"
            src={coin.iconUrl}
            alt={`${coin.name} (${coin.symbol}) icon`}
            width="50"
            height="50"
          />
        );
        break;
      case 'pixel':
        icon = (
          <img
            className="coin__icon"
            src={`${coin.iconUrl}?size=100`}
            alt={`${coin.name} (${coin.symbol}) icon`}
            width="50"
            height="50"
          />
        );
        break;
      default:
        icon = (
          <span className="coin__icon coin__icon--placeholder" />
        );
    }

    let { pair } = this.props;
    const symbols = this.props.pair.toUpperCase().split('_');
    if (this.props.changePair === 'to') {
      let fromCoin = symbols[0];
      if (fromCoin === coin.symbol) [, fromCoin] = symbols;
      pair = `${fromCoin}_${coin.symbol}`;
    }
    if (this.props.changePair === 'from') {
      let toCoin = symbols[1];
      if (toCoin === coin.symbol) [toCoin] = symbols;
      pair = `${coin.symbol}_${toCoin}`;
    }

    if (!this.props.coinStore.constructor.isAvailable(coin)) {
      return (
        <div className="coin__item" key={i}>
          <div className="coin coin--disabled">
            {icon}
            <div className="coin__name">{coin.name}</div>
            <div className="coin__symbol">{coin.symbol}</div>
          </div>
        </div>
      );
    }

    return (
      <div className="coin__item" key={i}>
        <Link className="coin" to={`/${pair}`}>
          {icon}
          <div className="coin__name">{coin.name}</div>
          <div className="coin__symbol">{coin.symbol}</div>
        </Link>
      </div>
    );
  }

  render() {
    return (
      <Modal leftButton={<BackButton href={`/${this.props.pair}`} />} title={this.props.title} large light>
        <div className="from">
          <form onSubmit={this.submit}>
            <FormControl
              type="text"
              id="search"
              prepend={<img src={search} width="19" height="19" alt="Search" />}
              onChange={this.onSearch}
              value={this.state.search}
              color="transparent"
              placeholder="Search coin"
            />
          </form>
          <div className="coin__list">
            {this.state.coins.map(this.renderCoin)}
          </div>
          {!this.state.search && this.props.coinStore.total > this.props.coinStore.coins.length ?
            <div className="coin__footer">
              <Button
                type="button"
                color="blue"
                text="Load more"
                onClick={this.loadMore}
              />
            </div>
          : null}
        </div>
      </Modal>
    );
  }
}

SelectCoin.propTypes = {
  changePair: PropTypes.string.isRequired,
  pair: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  coinStore: PropTypes.object.isRequired,
};

export default SelectCoin;



// WEBPACK FOOTER //
// ./src/scenes/Pair/scenes/SelectCoin/index.jsx